import { render, staticRenderFns } from "./SettingsHeader.vue?vue&type=template&id=067f56c3&scoped=true"
import script from "./SettingsHeader.vue?vue&type=script&lang=js"
export * from "./SettingsHeader.vue?vue&type=script&lang=js"
import style0 from "./SettingsHeader.vue?vue&type=style&index=0&id=067f56c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067f56c3",
  null
  
)

export default component.exports